<app-upsell-card
  htmlTitle="<strong>Recommended:</strong> Add a Wellness Lab Test"
  question="Would you like to add this Wellness panel to your treatment plan?"
  [slug]="slug"
>
  <p class="mb-4">
    <strong>We highly recommend adding a wellness panel to your GLP-1 treatment plan.</strong> This comprehensive
    <strong>urine and blood test</strong> evaluates important health markers like kidney and liver function,
    cholesterol, blood sugar, and thyroid levels-ensuring your treatment is safe and effective.
  </p>
  <p class="mb-4">
    We have partnered with thousands of
    <span data-qa-id="Labs Across the Country Button" class="modalLink" (click)="toggleLabFinderModal()"
      >labs across the country</span
    >
    to conduct this test and provide results within 12-24 hours.
  </p>
</app-upsell-card>

<app-lab-finder-modal
  *ngIf="showLabFinderModal"
  [(active)]="showLabFinderModal"
  searchDescription="To find the nearest lab for your Wellness lab test, please enter your zip code below. These labs do not require an appointment."
></app-lab-finder-modal>
